<div class="file">
    <img *ngIf="!!imageUrl" [src]="imageUrl" alt="" />
    <div class="body">
        <div i18n>Laddar upp: {{file.file.name}} {{fileSize}}</div>
        <mat-progress-bar *ngIf="!file.status?.body?.error" color="primary" mode="determinate" [value]="file.status?.progress"></mat-progress-bar>
        <span class="error" *ngIf="file.status?.body?.error">{{file.status?.body?.error?.message}}</span>
    </div>
    <button mat-icon-button  color="warn" (click)="cancel()"><mat-icon>close</mat-icon></button>
</div>